import React, { useState, useMemo } from 'react';
import MainLayout from '../../components/MainLayout';
import Pagination from '../../components/common/Pagination';
import './IPManagementPage.css';

function IPManagementPage() {
  const [ipList, setIpList] = useState([
    {
      id: 1,
      ipAddress: '192.168.1.100',
      description: '관리자 PC',
      accessLevel: '전체',
      status: '허용',
      lastAccess: '2025-10-20 14:30:22',
      createdAt: '2025-01-15',
      createdBy: '관리자'
    },
    {
      id: 2,
      ipAddress: '192.168.1.101',
      description: '개발팀 서버',
      accessLevel: '개발',
      status: '허용',
      lastAccess: '2025-10-20 13:15:10',
      createdAt: '2025-02-01',
      createdBy: '시스템관리자'
    },
    {
      id: 3,
      ipAddress: '192.168.1.102',
      description: '공장 모니터링 단말',
      accessLevel: '모니터링',
      status: '허용',
      lastAccess: '2025-10-20 14:25:45',
      createdAt: '2025-03-10',
      createdBy: '관리자'
    },
    {
      id: 4,
      ipAddress: '10.0.0.50',
      description: '외부 접속 차단',
      accessLevel: '없음',
      status: '차단',
      lastAccess: '2025-10-19 22:15:30',
      createdAt: '2025-10-19',
      createdBy: '보안담당자'
    },
    {
      id: 5,
      ipAddress: '192.168.1.200',
      description: '백업 서버',
      accessLevel: '시스템',
      status: '허용',
      lastAccess: '2025-10-20 02:00:00',
      createdAt: '2025-01-20',
      createdBy: '시스템관리자'
    }
  ]);

  const [selectedIP, setSelectedIP] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [filterStatus, setFilterStatus] = useState('전체');

  // 페이지네이션 상태
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const [newIP, setNewIP] = useState({
    ipAddress: '',
    description: '',
    accessLevel: '모니터링',
    status: '허용'
  });

  const handleIPClick = (ip) => {
    setSelectedIP(ip);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedIP(null);
  };

  const handleOpenAddModal = () => {
    setIsAddModalOpen(true);
    setNewIP({
      ipAddress: '',
      description: '',
      accessLevel: '모니터링',
      status: '허용'
    });
  };

  const handleCloseAddModal = () => {
    setIsAddModalOpen(false);
    setNewIP({
      ipAddress: '',
      description: '',
      accessLevel: '모니터링',
      status: '허용'
    });
  };

  const handleInputChange = (field, value) => {
    setNewIP(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleAddIP = () => {
    // IP 주소 유효성 검사
    const ipPattern = /^(\d{1,3}\.){3}\d{1,3}$/;
    if (!ipPattern.test(newIP.ipAddress)) {
      alert('올바른 IP 주소 형식을 입력해주세요.');
      return;
    }

    // 중복 IP 검사
    const isDuplicate = ipList.some(ip => ip.ipAddress === newIP.ipAddress);
    if (isDuplicate) {
      alert('이미 등록된 IP 주소입니다.');
      return;
    }

    // 설명 필수 입력 검사
    if (!newIP.description.trim()) {
      alert('설명을 입력해주세요.');
      return;
    }

    const now = new Date();
    const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const formattedTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

    const newIPEntry = {
      id: ipList.length + 1,
      ipAddress: newIP.ipAddress,
      description: newIP.description,
      accessLevel: newIP.accessLevel,
      status: newIP.status,
      lastAccess: '-',
      createdAt: formattedDate,
      createdBy: '관리자'
    };

    setIpList([...ipList, newIPEntry]);
    handleCloseAddModal();
    alert('IP가 성공적으로 추가되었습니다.');
  };

  const filteredIPs = useMemo(() => {
    return ipList.filter(ip => {
      const statusMatch = filterStatus === '전체' || ip.status === filterStatus;
      return statusMatch;
    });
  }, [ipList, filterStatus]);

  // 페이지네이션 적용된 데이터
  const paginatedIPs = useMemo(() => {
    const startIndex = page * size;
    return filteredIPs.slice(startIndex, startIndex + size);
  }, [filteredIPs, page, size]);

  const totalElements = filteredIPs.length;
  const totalPages = Math.ceil(totalElements / size);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSizeChange = (newSize) => {
    setSize(newSize);
    setPage(0);
  };

  const handleFilterStatusChange = (e) => {
    setFilterStatus(e.target.value);
    setPage(0);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case '허용': return { bg: 'rgba(74, 222, 128, 0.1)', color: '#4ADE80' };
      case '차단': return { bg: 'rgba(239, 68, 68, 0.1)', color: '#EF4444' };
      case '대기': return { bg: 'rgba(251, 191, 36, 0.1)', color: '#FBBF24' };
      default: return { bg: '#2D3339', color: '#9CA3AF' };
    }
  };

  const getAccessLevelColor = (level) => {
    switch (level) {
      case '전체': return '#3B82F6';
      case '시스템': return '#8B5CF6';
      case '개발': return '#10B981';
      case '모니터링': return '#F59E0B';
      case '없음': return '#6B7280';
      default: return '#9CA3AF';
    }
  };

  return (
    <MainLayout>
      <div className="ip-management-container">
        {/* Header Section */}
        <div className="ip-management-header">
          <div className="ip-management-header-left">
            <div className="ip-management-title">IP 관리</div>
            <p className="ip-management-subtitle">접근 IP 주소 및 권한 제어 관리</p>
          </div>
          <div className="ip-management-header-right">
            {/* Optional update info */}
          </div>
        </div>

        <div className="ip-management-content">
          <div className="ip-stats">
            <div className="stat-card">
              <div className="stat-icon" style={{background: 'rgba(74, 158, 255, 0.1)'}}>
                <span className="material-symbols-outlined" style={{color: '#4A9EFF'}}>dns</span>
              </div>
              <div className="stat-info">
                <div className="stat-label">전체 IP</div>
                <div className="stat-value">{ipList.length}개</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{background: 'rgba(74, 222, 128, 0.1)'}}>
                <span className="material-symbols-outlined" style={{color: '#4ADE80'}}>check_circle</span>
              </div>
              <div className="stat-info">
                <div className="stat-label">허용</div>
                <div className="stat-value">{ipList.filter(ip => ip.status === '허용').length}개</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{background: 'rgba(239, 68, 68, 0.1)'}}>
                <span className="material-symbols-outlined" style={{color: '#EF4444'}}>block</span>
              </div>
              <div className="stat-info">
                <div className="stat-label">차단</div>
                <div className="stat-value">{ipList.filter(ip => ip.status === '차단').length}개</div>
              </div>
            </div>
          </div>

          {/* Controls Section */}
          <div className="ip-controls">
            <div className="control-left">
              <label className="control-label">상태</label>
              <div className="dropdown-container">
                <select
                  className="status-dropdown"
                  value={filterStatus}
                  onChange={handleFilterStatusChange}
                >
                  <option value="전체">전체</option>
                  <option value="허용">허용</option>
                  <option value="차단">차단</option>
                  <option value="대기">대기</option>
                </select>
                <svg className="dropdown-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <div className="control-right">
              <button className="btn-add-ip" onClick={handleOpenAddModal}>
                <svg className="plus-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                IP 추가
              </button>
            </div>
          </div>

          <div className="ip-table-container">
            <table className="ip-table">
              <thead>
                <tr>
                  <th>IP 주소</th>
                  <th>설명</th>
                  <th>접근 권한</th>
                  <th>상태</th>
                  <th>최근 접속</th>
                  <th>등록일</th>
                  <th>등록자</th>
                  <th>작업</th>
                </tr>
              </thead>
              <tbody>
                {paginatedIPs.map((ip) => (
                  <tr key={ip.id} onClick={() => handleIPClick(ip)}>
                    <td>
                      <div className="ip-address">
                        <span className="material-symbols-outlined">computer</span>
                        {ip.ipAddress}
                      </div>
                    </td>
                    <td>{ip.description}</td>
                    <td>
                      <span
                        className="access-level-badge"
                        style={{
                          background: `${getAccessLevelColor(ip.accessLevel)}20`,
                          color: getAccessLevelColor(ip.accessLevel)
                        }}
                      >
                        {ip.accessLevel}
                      </span>
                    </td>
                    <td>
                      <span
                        className="status-badge"
                        style={{
                          background: getStatusColor(ip.status).bg,
                          color: getStatusColor(ip.status).color
                        }}
                      >
                        {ip.status}
                      </span>
                    </td>
                    <td>{ip.lastAccess}</td>
                    <td>{ip.createdAt}</td>
                    <td>{ip.createdBy}</td>
                    <td>
                      <div className="action-buttons">
                        <button className="btn-icon" onClick={(e) => { e.stopPropagation(); }}>
                          <span className="material-symbols-outlined">edit</span>
                        </button>
                        <button className="btn-icon" onClick={(e) => { e.stopPropagation(); }}>
                          <span className="material-symbols-outlined">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalElements > 0 && (
              <Pagination
                page={page}
                totalPages={totalPages}
                totalElements={totalElements}
                size={size}
                onPageChange={handlePageChange}
                onSizeChange={handleSizeChange}
              />
            )}
          </div>
        </div>

        {/* IP 추가 모달 */}
        {isAddModalOpen && (
          <>
            <div className="modal-overlay" onClick={handleCloseAddModal}></div>
            <div className="ip-add-modal">
              <div className="modal-header">
                <h3>IP 추가</h3>
                <button className="btn-close" onClick={handleCloseAddModal}>
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>
              <div className="modal-content">
                <div className="form-section">
                  <label>IP 주소 <span className="required">*</span></label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="예: 192.168.1.100"
                    value={newIP.ipAddress}
                    onChange={(e) => handleInputChange('ipAddress', e.target.value)}
                  />
                </div>
                <div className="form-section">
                  <label>설명 <span className="required">*</span></label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="IP 주소에 대한 설명을 입력하세요"
                    value={newIP.description}
                    onChange={(e) => handleInputChange('description', e.target.value)}
                  />
                </div>
                <div className="form-section">
                  <label>접근 권한</label>
                  <select
                    className="form-select"
                    value={newIP.accessLevel}
                    onChange={(e) => handleInputChange('accessLevel', e.target.value)}
                  >
                    <option value="전체">전체</option>
                    <option value="시스템">시스템</option>
                    <option value="개발">개발</option>
                    <option value="모니터링">모니터링</option>
                    <option value="없음">없음</option>
                  </select>
                </div>
                <div className="form-section">
                  <label>상태</label>
                  <select
                    className="form-select"
                    value={newIP.status}
                    onChange={(e) => handleInputChange('status', e.target.value)}
                  >
                    <option value="허용">허용</option>
                    <option value="차단">차단</option>
                    <option value="대기">대기</option>
                  </select>
                </div>
                <div className="form-info">
                  <span className="material-symbols-outlined">info</span>
                  <p>IP 주소는 IPv4 형식으로 입력해주세요. (예: 192.168.1.100)</p>
                </div>
              </div>
              <div className="modal-actions">
                <button className="btn-primary" onClick={handleAddIP}>추가</button>
                <button className="btn-secondary" onClick={handleCloseAddModal}>취소</button>
              </div>
            </div>
          </>
        )}

        {/* IP 상세 모달 */}
        {isModalOpen && selectedIP && (
          <>
            <div className="modal-overlay" onClick={handleCloseModal}></div>
            <div className="ip-detail-modal">
              <div className="modal-header">
                <h3>IP 상세정보</h3>
                <button className="btn-close" onClick={handleCloseModal}>
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>
              <div className="modal-content">
                <div className="detail-section">
                  <label>IP 주소</label>
                  <div className="detail-value">{selectedIP.ipAddress}</div>
                </div>
                <div className="detail-section">
                  <label>설명</label>
                  <div className="detail-value">{selectedIP.description}</div>
                </div>
                <div className="detail-section">
                  <label>접근 권한</label>
                  <div className="detail-value">
                    <span
                      className="access-level-badge"
                      style={{
                        background: `${getAccessLevelColor(selectedIP.accessLevel)}20`,
                        color: getAccessLevelColor(selectedIP.accessLevel)
                      }}
                    >
                      {selectedIP.accessLevel}
                    </span>
                  </div>
                </div>
                <div className="detail-section">
                  <label>상태</label>
                  <div className="detail-value">
                    <span
                      className="status-badge"
                      style={{
                        background: getStatusColor(selectedIP.status).bg,
                        color: getStatusColor(selectedIP.status).color
                      }}
                    >
                      {selectedIP.status}
                    </span>
                  </div>
                </div>
                <div className="detail-section">
                  <label>최근 접속</label>
                  <div className="detail-value">{selectedIP.lastAccess}</div>
                </div>
                <div className="detail-section">
                  <label>등록일</label>
                  <div className="detail-value">{selectedIP.createdAt}</div>
                </div>
                <div className="detail-section">
                  <label>등록자</label>
                  <div className="detail-value">{selectedIP.createdBy}</div>
                </div>
              </div>
              <div className="modal-actions">
                <button className="btn-primary">수정</button>
                <button className="btn-secondary" onClick={handleCloseModal}>닫기</button>
              </div>
            </div>
          </>
        )}
      </div>
    </MainLayout>
  );
}

export default IPManagementPage;
